import React, { useState, useEffect } from 'react';
import { Grid, GridItem, FormControl, FormLabel, Box, Button, Flex, Select, Input, Text, useToast, Table, Thead, Tbody, Tr, Th, Td, VStack, Collapse, IconButton } from '@chakra-ui/react';
import { DownloadIcon, ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import OrderApi from 'api/orders';
import StoresApi from 'api/stores';
import CompaniesApi from 'api/companies';
import { OrderTypeOptions, TransactionPaymentMethod } from 'config/constant';
import DashboardReportApi from 'api/dashboardreport';
import { Select as MultiSelect } from 'chakra-react-select';


// API Calls (Mock)
// API Calls
const getOrderData = async (filters) => {
  try {
    let response = await DashboardReportApi.GetReports({
      type: 'complete-order',
      ...filters,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching order data:', error);
    return { status_code: 500, data: [] };
  }
};

const getTalleyData = async (company, orderType) => {
  return {
    status_code: 200,
    data: [
      { id: 1, name: 'Talley 1', details: 'Details for Talley 1' },
      { id: 2, name: 'Talley 2', details: 'Details for Talley 2' },
    ],
  };
};

const getCustomerData = async () => {
  return {
    status_code: 200,
    data: [
      { id: 1, name: 'Customer 1', details: 'Details for Customer 1' },
      { id: 2, name: 'Customer 2', details: 'Details for Customer 2' },
    ],
  };
};

// Form Components
// const OrderDataForm = ({ setData, companiesList, storeList }) => {
//   const [company, setCompany] = useState('');
//   const [store, setStore] = useState('');
//   const [orderType, setOrderType] = useState('');
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');

//   const filteredStores = storeList.filter((store) => store.company_id === company);

//   const handleSubmit = async () => {
//     // Here you might want to send dates as well to your API
//     const response = await getOrderData(company, store, orderType, dateFrom, dateTo);
//     if (response.status_code === 200) {
//       setData(response.data); // Assuming data is returned in response.data
//     }
//   };

//   return (
//     <VStack spacing={4} align="stretch">
//       <Select
//         placeholder="Select Company"
//         value={company}
//         onChange={(e) => {
//           setCompany(e.target.value);
//           setStore(''); // Reset store when company changes
//         }}
//       >
//         {companiesList.map((option) => (
//           <option key={option.id} value={option.id}>
//             {option.name}
//           </option>
//         ))}
//       </Select>

//       <Select
//         placeholder="Select Store"
//         value={store}
//         onChange={(e) => setStore(e.target.value)}
//         isDisabled={!company}
//       >
//         {filteredStores.map((option) => (
//           <option key={option.id} value={option.id}>
//             {option.name} ({option.store_code})
//           </option>
//         ))}
//       </Select>

//       <Select
//         placeholder="Select Order Type"
//         value={orderType}
//         onChange={(e) => setOrderType(e.target.value)}
//       >
//         {OrderTypeOptions.map((option) => (
//           <option key={option.value} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </Select>

//       {/* Date Inputs */}
//       <Input
//         type="date"
//         placeholder="From Date"
//         value={dateFrom}
//         onChange={(e) => setDateFrom(e.target.value)}
//       />
//       <Input
//         type="date"
//         placeholder="To Date"
//         value={dateTo}
//         onChange={(e) => setDateTo(e.target.value)}
//         min={dateFrom} // Prevent selecting 'To' date earlier than 'From'
//       />

//       <Button
//         onClick={handleSubmit}
//         mt={4}
//         leftIcon={<DownloadIcon />}
//         colorScheme="blue"
//         size="lg"
//         borderRadius="md"
//         px={8}
//         py={6}
//         _hover={{
//           bg: 'blue.600',
//           boxShadow: 'xl',
//         }}
//         _active={{
//           bg: 'blue.700',
//         }}
//       >
//         Download File
//       </Button>
//     </VStack>
//   );
// };

const OrderDataForm = ({ setData, setTotal, companiesList, storeList, currentPage, setCurrentPage, itemsPerPage }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [orderType, setOrderType] = useState([]);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);

  const filteredStores = storeList.filter((store) => store.company_id === company);

  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const handleSubmit = async (isDownload = false) => {
    setLoading(true);
    const filters = {
      company_id: company,
      store_id: store,
      start_date: dateFrom,
      end_date: dateTo,
      order_type: orderType.map(item => item.value).join(','),
      limit: itemsPerPage,
      offset: (currentPage) * itemsPerPage,
      download: isDownload,
    };
    const response = await getOrderData(filters);
    setLoading(false);
    if (response.status_code === 200) {
      if (isDownload) {
        // Handle CSV string download
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `report_${new Date().getTime()}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setData(response.data.list);
        setTotal(response.data.total);
        setIsDirty(false);
        // setShowFilters(false); // Removed as per user preference to stay cleaner or keep it manual
      }
    }
  };

  const handleClear = () => {
    setCompany('');
    setStore('');
    setOrderType([]);
    setDateFrom('');
    setDateTo('');
    setIsDirty(false);
    setShowFilters(true);
    // Fetch data with empty filters immediately
    getOrderData({
      company_id: '',
      store_id: '',
      start_date: '',
      end_date: '',
      order_type: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  useEffect(() => {
    handleSubmit(false);
  }, []);

  useEffect(() => {
    if (company || store || orderType.length > 0 || dateFrom || dateTo) {
      handleSubmit(false);
    }
  }, [currentPage]);

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleSubmit(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleSubmit(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Store</FormLabel>
              <Select
                placeholder="Select Store"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>

          <GridItem colSpan={{ base: 1, md: 2 }}>
            <FormControl>
              <FormLabel>Select Order Type</FormLabel>
              <MultiSelect
                isMulti
                options={OrderTypeOptions}
                placeholder="Select Order Type(s)"
                value={orderType}
                onChange={(val) => onFilterChange(setOrderType, val)}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                portalZIndex={99999}
                chakraStyles={{
                  menuPortal: (provided) => ({ ...provided, zIndex: 99999 }),
                  menu: (provided) => ({ ...provided, zIndex: 99999 }),
                  menuList: (provided) => ({ ...provided, zIndex: 99999 }),
                }}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const ReferalForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'referral',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `referral_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Referral Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'referral',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Referral Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Enroll Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const EnrollmentForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'enrollment',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `enrollment_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Enrollment Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'enrollment',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Enrollment Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Enroll Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Enroll Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const InstallmentForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'installment',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `enrollment_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Enrollment Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'installment',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Enrollment Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Enroll Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Enroll Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const AccountTotalInstallmentForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [category, setCategory] = useState('');
  const [months, setMonths] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (downloadFormat = null) => {
    setLoading(true);
    try {
      const filters = {
        type: 'accounttotalinstallment',
        company_id: company,
        store_id: store,
        category: category,
        months: months,
        payment_mode: paymentMode,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: !!downloadFormat,
        format: downloadFormat
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (downloadFormat === 'csv') {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `account_total_installment_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (downloadFormat === 'xml' || downloadFormat === 'ledger_xml') {
          const blob = new Blob([response.data], { type: 'application/xml;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `${downloadFormat === 'ledger_xml' ? 'ledger_xml_report_' : 'account_total_installment_report_'}${new Date().getTime()}.xml`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Enrollment Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setCategory('');
    setMonths('');
    setPaymentMode('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'accounttotalinstallment',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      category: '',
      months: '',
      payment_mode: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(null);
  }, []);

  useEffect(() => {
    handleFetchData(null);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(null);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData('csv')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download CSV
          </Button>
          <Button
            onClick={() => handleFetchData('xml')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="green"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download XML
          </Button>
          <Button
            onClick={() => handleFetchData('ledger_xml')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="teal"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Ledger XML
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Account Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Category</FormLabel>
              <Select
                placeholder="Select Category"
                value={category}
                onChange={(e) => onFilterChange(setCategory, e.target.value)}
              >
                <option value="Gold">Gold</option>
                <option value="Dhanavarsha">Dhanavarsha</option>
                <option value="Diamond">Diamond</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Months</FormLabel>
              <Select
                placeholder="Select Months"
                value={months}
                onChange={(e) => onFilterChange(setMonths, e.target.value)}
              >
                <option value="24">24</option>
                <option value="12">12</option>
                <option value="11">11</option>
                <option value="6">6</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Payment Mode</FormLabel>
              <Select
                placeholder="Select Payment Mode"
                value={paymentMode}
                onChange={(e) => onFilterChange(setPaymentMode, e.target.value)}
              >
                {TransactionPaymentMethod.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const AbpInstallmentForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (downloadFormat = null) => {
    setLoading(true);
    try {
      const filters = {
        type: 'abpinstallment',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: !!downloadFormat,
        format: downloadFormat
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (downloadFormat === 'csv') {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `abp_installment_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (downloadFormat === 'xml' || downloadFormat === 'ledger_xml') {
          const blob = new Blob([response.data], { type: 'application/xml;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `${downloadFormat === 'ledger_xml' ? 'ledger_xml_report_' : 'abp_installment_report_'}${new Date().getTime()}.xml`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in ABP Installment Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    getOrderData({
      type: 'abpinstallment',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(null);
  }, []);

  useEffect(() => {
    handleFetchData(null);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(null);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData('csv')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download CSV
          </Button>
          <Button
            onClick={() => handleFetchData('xml')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="green"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download XML
          </Button>
          <Button
            onClick={() => handleFetchData('ledger_xml')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="teal"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Ledger XML
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Account Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const CashDepositForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'cashreport',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `cash_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Enrollment Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'cashreport',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Enrollment Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Cash Payment Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Cash Payment Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};


const WithdrawalMoneySavingPlanForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [category, setCategory] = useState('');
  const [months, setMonths] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (downloadFormat = null) => {
    setLoading(true);
    try {
      const filters = {
        type: 'accountwithdrawalmoneysavingplan',
        company_id: company,
        store_id: store,
        category: category,
        months: months,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: !!downloadFormat,
        format: downloadFormat
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (downloadFormat === 'csv') {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `withdrawal_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (downloadFormat === 'xml') {
          const blob = new Blob([response.data], { type: 'application/xml;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `withdrawal_report_${new Date().getTime()}.xml`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Withdrawal Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setCategory('');
    setMonths('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'accountwithdrawalmoneysavingplan',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      category: '',
      months: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Withdrawal Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData('csv')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download CSV
          </Button>
          <Button
            onClick={() => handleFetchData('xml')}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="green"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download XML
          </Button>

          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Category</FormLabel>
              <Select
                placeholder="Select Category"
                value={category}
                onChange={(e) => onFilterChange(setCategory, e.target.value)}
              >
                <option value="Gold">Gold</option>
                <option value="Dhanavarsha">Dhanavarsha</option>
                <option value="Diamond">Diamond</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Months</FormLabel>
              <Select
                placeholder="Select Months"
                value={months}
                onChange={(e) => onFilterChange(setMonths, e.target.value)}
              >
                <option value="24">24</option>
                <option value="12">12</option>
                <option value="11">11</option>
                <option value="6">6</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};


const AbpSellGoldForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'abpsellgold',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `abp_sell_gold_withdrawal_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in ABP Sell Gold Withdrawal Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    getOrderData({
      type: 'abpsellgold',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">ABP Sell Gold & Withdrawal Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};


const SellGoldWithdrawalForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [category, setCategory] = useState('');
  const [months, setMonths] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'sellgoldwithdrawalmoneysavingplan',
        company_id: company,
        store_id: store,
        category: category,
        months: months,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `sell_gold_withdrawal_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Sell Gold Withdrawal Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setCategory('');
    setMonths('');
    setIsDirty(false);
    // Fetch with cleared dates
    getOrderData({
      type: 'sellgoldwithdrawalmoneysavingplan',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      category: '',
      months: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Sell Gold Withdrawal Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Category</FormLabel>
              <Select
                placeholder="Select Category"
                value={category}
                onChange={(e) => onFilterChange(setCategory, e.target.value)}
              >
                <option value="Gold">Gold</option>
                <option value="Dhanavarsha">Dhanavarsha</option>
                <option value="Diamond">Diamond</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Months</FormLabel>
              <Select
                placeholder="Select Months"
                value={months}
                onChange={(e) => onFilterChange(setMonths, e.target.value)}
              >
                <option value="24">24</option>
                <option value="12">12</option>
                <option value="11">11</option>
                <option value="6">6</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const AbpJewelleryRedeemForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'ABP_JEWELLERY_REDEEM',
        company_id: company,
        store_id: store,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `abp_buy_jewellery_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in ABP Buy Jewellery Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setIsDirty(false);
    getOrderData({
      type: 'ABP_JEWELLERY_REDEEM',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">ABP Buy Jewellery Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};

const CloseSavingPlanForm = ({ setData, setTotal, currentPage, setCurrentPage, itemsPerPage, companiesList, storeList }) => {
  const [company, setCompany] = useState('');
  const [store, setStore] = useState('');
  const [category, setCategory] = useState('');
  const [months, setMonths] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const filteredStores = storeList.filter((s) => s.company_id === company);

  const handleFetchData = async (isDownload = false) => {
    setLoading(true);
    try {
      const filters = {
        type: 'close_saving_plan',
        company_id: company,
        store_id: store,
        category: category,
        months: months,
        start_date: dateFrom,
        end_date: dateTo,
        limit: itemsPerPage,
        offset: currentPage * itemsPerPage,
        download: isDownload,
      };
      const response = await getOrderData(filters);

      if (response.status_code === 200) {
        if (isDownload) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `buy_jewelry_saving_plan_report_${new Date().getTime()}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setData(response.data.list);
          setTotal(response.data.total);
          setIsDirty(false);
        }
      }
    } catch (error) {
      console.error('Error in Buy Jewellery Saving Plan Report:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDateFrom('');
    setDateTo('');
    setCompany('');
    setStore('');
    setCategory('');
    setMonths('');
    setIsDirty(false);
    getOrderData({
      type: 'close_saving_plan',
      start_date: '',
      end_date: '',
      company_id: '',
      store_id: '',
      category: '',
      months: '',
      limit: itemsPerPage,
      offset: 0,
      download: false,
    }).then(response => {
      if (response.status_code === 200) {
        setData(response.data.list);
        setTotal(response.data.total);
      }
    });
  };

  const onFilterChange = (setter, value) => {
    setter(value);
    setIsDirty(true);
  };

  useEffect(() => {
    handleFetchData(false);
  }, []);

  useEffect(() => {
    handleFetchData(false);
  }, [currentPage]);

  return (
    <VStack spacing={4} w="100%" align="stretch" position="relative" zIndex={100}>
      <Flex justify="space-between" align="center" bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex align="center" gap={4}>
          <Text fontSize="xl" fontWeight="bold">Buy Jewellery ( Saving Plan ) Filters</Text>
          <IconButton
            icon={showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowFilters(!showFilters)}
            variant="ghost"
            aria-label="Toggle Filters"
          />
        </Flex>

        <Flex gap={2}>
          {isDirty && (
            <Button
              onClick={() => {
                if (currentPage === 0) {
                  handleFetchData(false);
                } else {
                  setCurrentPage(0);
                }
              }}
              colorScheme="blue"
              size="sm"
              isLoading={loading}
              borderRadius="md"
            >
              Apply / View Data
            </Button>
          )}
          <Button
            onClick={() => handleFetchData(true)}
            leftIcon={<DownloadIcon />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isLoading={loading}
            borderRadius="md"
          >
            Download
          </Button>
          <Button
            onClick={handleClear}
            variant="ghost"
            colorScheme="red"
            size="sm"
            borderRadius="md"
          >
            Clear
          </Button>
        </Flex>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={8}
          alignItems="center"
          p={4}
          bg="gray.50"
          borderRadius="md"
        >
          <GridItem>
            <FormControl>
              <FormLabel>Select Company</FormLabel>
              <Select
                placeholder="Select Company"
                value={company}
                onChange={(e) => {
                  onFilterChange(setCompany, e.target.value);
                  setStore('');
                }}
              >
                {companiesList && companiesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Select Account Branch</FormLabel>
              <Select
                placeholder="Select Branch"
                value={store}
                onChange={(e) => onFilterChange(setStore, e.target.value)}
                isDisabled={!company}
              >
                {filteredStores.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name} ({option.store_code})
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Category</FormLabel>
              <Select
                placeholder="Select Category"
                value={category}
                onChange={(e) => onFilterChange(setCategory, e.target.value)}
              >
                <option value="Gold">Gold</option>
                <option value="Dhanavarsha">Dhanavarsha</option>
                <option value="Diamond">Diamond</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Months</FormLabel>
              <Select
                placeholder="Select Months"
                value={months}
                onChange={(e) => onFilterChange(setMonths, e.target.value)}
              >
                <option value="24">24</option>
                <option value="12">12</option>
                <option value="11">11</option>
                <option value="6">6</option>
              </Select>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(e) => onFilterChange(setDateFrom, e.target.value)}
              />
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl>
              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(e) => onFilterChange(setDateTo, e.target.value)}
                min={dateFrom}
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Collapse>
    </VStack>
  );
};


const TalleyForm = ({ setData }) => {
  const [company, setCompany] = useState('');
  const [orderType, setOrderType] = useState('');

  const handleSubmit = async () => {
    const response = await getTalleyData(company, orderType);
    if (response.status_code === 200) {
      setData(response.data); // Assuming data is returned in response.data
    }
  };

  return (
    <Box>
      {/* <Select placeholder="Select Company" value={company} onChange={(e) => setCompany(e.target.value)}>
        {CompanyOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>

      <Select placeholder="Select Order Type" value={orderType} onChange={(e) => setOrderType(e.target.value)}>
        {OrderTypeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>

      <Button onClick={handleSubmit} mt={4}>Fetch Data</Button> */}
    </Box>
  );
};

const CustomerForm = ({ setData }) => {
  const handleSubmit = async () => {
    const response = await getCustomerData();
    if (response.status_code === 200) {
      setData(response.data); // Assuming data is returned in response.data
    }
  };

  return (
    <Box>
      <Button onClick={handleSubmit} mt={4}>Fetch Customer Data</Button>
    </Box>
  );
};

// Main Component
const ReportPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(localStorage.getItem('selectedCategory') || 'General');
  const [selectedReport, setSelectedReport] = useState(localStorage.getItem('selectedReport') || 'OrderData');

  const categoryOptions = ['General', 'Account'];
  const reportOptions = {
    'Account': [
      { value: 'accounttotalinstallment', label: 'Complete Installment Report' },
      { value: 'accountwithdrawalmoneysavingplan', label: 'Withdrawal Money Saving Plan Report' },
      { value: 'sellgoldwithdrawalmoneysavingplan', label: 'Sell Gold & Withdrawal Money Saving Plan' },
      { value: 'close_saving_plan', label: 'Buy Jewellery ( Saving Plan )' },
      { value: 'abpinstallment', label: 'ABP Installment Report' },
      { value: 'abpsellgold', label: 'ABP Sell Gold & Withdrawal Money' },
      { value: 'ABP_JEWELLERY_REDEEM', label: 'ABP Buy Jewellery' }
    ],
    'General': [
      { value: 'OrderData', label: 'Completed Order' },
      { value: 'enrollment', label: 'Enrollment Report' },
      { value: 'installment', label: 'Installment Report' },
      { value: 'Referal', label: 'Referral Report' },
      { value: 'cashreport', label: 'Cash Payment Report' },
    ]
  };
  const [tableData, setTableData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(20);
  const [loading, setLoading] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const [companiesList, setcompaniesList] = useState([]);
  const toast = useToast();


  useEffect(() => {
    FetchStoreList();
    FetchCompanies();
  }, []);

  const FetchStoreList = async () => {
    try {
      setLoading(true);
      let response = await StoresApi.List({
        currentPage: 0,
        itemsPerPage: 100,
        sort: 'name:asc',
        searchTerm: '',
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setStoreList(response?.data?.list);
      } else {
        setStoreList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const FetchCompanies = async () => {
    try {
      setLoading(true);
      let response = await CompaniesApi.List({});
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setcompaniesList(response?.data?.list);
      } else {
        setcompaniesList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const topScrollRef = React.useRef(null);
  const tableScrollRef = React.useRef(null);

  const syncScroll = (sourceRef, targetRef) => {
    if (!sourceRef.current || !targetRef.current) return;
    targetRef.current.scrollLeft = sourceRef.current.scrollLeft;
  };

  return (
    <Flex
      mt="8rem"
      px={{ base: '15px', md: '25px' }}
      justify="center"
      mb="20px"
      align="center"
      direction="column"
      gap={6}
    >

      <Flex w="100%" justify="flex-end" gap={4}>
        <Box minW="200px" maxW="300px">
          <Select
            value={selectedCategory}
            onChange={(e) => {
              const newCategory = e.target.value;
              setSelectedCategory(newCategory);
              localStorage.setItem('selectedCategory', newCategory);
              if (reportOptions[newCategory] && reportOptions[newCategory].length > 0) {
                const newReport = reportOptions[newCategory][0].value;
                setSelectedReport(newReport);
                localStorage.setItem('selectedReport', newReport);
              }
            }}
          >
            {categoryOptions.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </Select>
        </Box>

        <Box minW="200px" maxW="300px">
          <Select
            value={selectedReport}
            onChange={(e) => {
              const newReport = e.target.value;
              setSelectedReport(newReport);
              localStorage.setItem('selectedReport', newReport);
            }}
          >
            {reportOptions[selectedCategory]?.map((report) => (
              <option key={report.value} value={report.value}>
                {report.label}
              </option>
            ))}
          </Select>
        </Box>
      </Flex>

      {/* Display the relevant form based on selected report type */}
      {selectedReport === 'OrderData' && (
        <OrderDataForm
          setData={setTableData}
          setTotal={setTotalItems}
          companiesList={companiesList}
          storeList={storeList}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
        />
      )}
      {selectedReport === 'enrollment' && (
        <EnrollmentForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'accounttotalinstallment' && (
        <AccountTotalInstallmentForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'abpinstallment' && (
        <AbpInstallmentForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'installment' && (
        <InstallmentForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'Referal' && (
        <ReferalForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'accountwithdrawalmoneysavingplan' && (
        <WithdrawalMoneySavingPlanForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'sellgoldwithdrawalmoneysavingplan' && (
        <SellGoldWithdrawalForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'abpsellgold' && (
        <AbpSellGoldForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'close_saving_plan' && (
        <CloseSavingPlanForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'ABP_JEWELLERY_REDEEM' && (
        <AbpJewelleryRedeemForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'cashreport' && (
        <CashDepositForm
          setData={setTableData}
          setTotal={setTotalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          companiesList={companiesList}
          storeList={storeList}
        />
      )}
      {selectedReport === 'Talley' && <TalleyForm setData={setTableData} />}
      {selectedReport === 'Customer' && <CustomerForm setData={setTableData} />}

      {/* Table to display data */}
      {tableData && tableData.length > 0 && (
        <VStack w="100%" spacing={4}>
          <VStack w="100%" spacing={0} align="stretch" mt={4}>
            {/* 🔥 TOP HORIZONTAL SCROLLBAR */}
            <Box
              ref={topScrollRef}
              overflowX="auto"
              overflowY="hidden"
              onScroll={() => syncScroll(topScrollRef, tableScrollRef)}
            >
              <Box minW="1200px" h="1px" />
            </Box>

            {/* 🔥 TABLE CONTAINER */}
            <Box
              ref={tableScrollRef}
              w="100%"
              bg="white"
              borderRadius="lg"
              boxShadow="md"
              overflow="auto"
              maxH="500px"
              onScroll={() => syncScroll(tableScrollRef, topScrollRef)}
            >
              <Table variant="simple" minW="1200px">
                <Thead
                  bg="gray.100"
                >
                  <Tr>
                    {Object.keys(tableData[0]).map((key) => (
                      <Th
                        key={key}
                        textTransform="capitalize"
                        whiteSpace="nowrap"
                        bg="gray.100"
                      >
                        {key.replace(/_/g, ' ')}
                      </Th>
                    ))}
                  </Tr>
                </Thead>

                <Tbody>
                  {tableData.map((row, index) => (
                    <Tr key={row.id || index} _hover={{ bg: 'gray.50' }}>
                      {Object.keys(tableData[0]).map((key) => (
                        <Td key={key} whiteSpace="nowrap">
                          {row[key] == null
                            ? ''
                            : typeof row[key] === 'object'
                              ? JSON.stringify(row[key])
                              : row[key]}
                        </Td>
                      ))}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </VStack>

          {/* 🔥 PAGINATION */}
          <Flex w="100%" justify="space-between" align="center" px={4}>
            <Text fontSize="sm" color="gray.600">
              Showing {currentPage * itemsPerPage + 1} to{' '}
              {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of{' '}
              {totalItems} results
            </Text>

            <Flex gap={2}>
              <Button
                size="sm"
                onClick={() => setCurrentPage((prev) => Math.max(0, prev - 1))}
                isDisabled={currentPage === 0}
              >
                Previous
              </Button>

              <Button
                size="sm"
                onClick={() => setCurrentPage((prev) => prev + 1)}
                isDisabled={(currentPage + 1) * itemsPerPage >= totalItems}
              >
                Next
              </Button>
            </Flex>
          </Flex>
        </VStack>
      )}


    </Flex>
  );
};

export default ReportPage;
